import { API, graphqlOperation} from "aws-amplify"
import { sortedAnalizeItemByType, } from '../graphql/queries'
import { analizeItemByCompany, } from '../graphql/queries'
import { sortedAnalizeSetByType, } from '../graphql/queries'
import { analizeTypeGroupByCategory, } from '../graphql/queries'
import { sortedCodesByType, } from '../graphql/queries'
import { analizeTypeByGroup, } from '../graphql/queries'
import { analizeItemSubByType, } from '../graphql/queries'
import { oilTypeByCategory, } from '../graphql/queries'

export default {
    data: () => ({
//        analizeItemListInclude: [],
//        AnalizeItemsInclude: [],
        itemNames:[
            // "一般label" label 
            {key:"マイ機器名", 
                value:{
                "一般label":"サンプル名",
                "航空機label":"SAMPLE NAME",
                "一般message":"マイ機器名",
                "航空機message":"マイ機器名（装備品）",
                "一般証明書":true,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"機器やサンプルの名前を入力してください。（ＸＸ＿旋回ミッション、ＸＸ＿前エンジンなど）",
                "航空機description":"機器やサンプルの名前を入力してください。（ＸＸ＿旋回ミッション、ＸＸ＿前エンジンなど）",
            }},
            {key:"マイ機器名_機体",
                value:{
                "一般label":"マイ機器名（機体）",
                "航空機label":"AIRCRAFT No",
                "一般message":"-",
                "航空機message":"マイ機器名（機体）",
                "一般証明書":false,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"",
                "航空機description":"機体の識別情報を入力してください。（資産管理番号、車体番号、ナンバーなど）",
            }},
            {key:"マイ機器ＩＤ",
                value:{
                "一般label":"識別名",
                "航空機label":"REGISTRATION NUMBER（S/N）",
                "一般message":"マイ機器ＩＤ",
                "航空機message":"マイ機器ＩＤ（装備品）",
                "一般証明書":true,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"機器やサンプルの識別名を入力してください。（資産管理番号、車体番号、ナンバーなど）",
                "航空機description":"装備品製造番号（S/N）を入力してください。",
            }},
/*
            {key:"マイ機器ＩＤ_機体",
                value:{
                "一般label":"マイ機器ＩＤ（機体）",
                "航空機label":"AIRCRAFT No",
                "一般message":"-",
                "航空機message":"マイ機器名（機体）",
                "一般証明書":false,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"機体の識別情報を入力してください。（資産管理番号、車体番号、ナンバーなど）",
                "航空機description":"機体番号を入力してください。（ＪＡＸＸＸＸなど）",
            }},
*/

            {key:"顧客名", 
             value:{
                "一般label":"顧客名",
                "航空機label":"顧客名",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":true,
                "航空機証明書": false,
                "一般counter":50,
                "航空機counter":50,
                "一般description":"機器の顧客名（所有者）が異なる場合は入力してください。",
                "航空機description":"機器の顧客名（所有者）が異なる場合は入力してください。",
            }},

            {key:"機械名", 
             value:{
                "一般label":"機械名",
                "航空機label":"SAMPLE COMPONENT",
                "一般message":"-",
                "航空機message":"機械名",
                "一般証明書":true,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"機械名を入力してくだい。（１号ｶﾞｽﾀｰﾋﾞﾝ、軸受など）",
                "航空機description":"装備品を入力してください。（ＥＮＧ、ＭＧＢ、ＴＧＢなど）",
            }},
            {key:"機械名_機体", 
             value:{
                "一般label":"機体名",
                "航空機label":"機体名",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般counter":20,
                "航空機counter":15
            }},
            {key:"製造メーカー名", 
             value:{
                "一般label":"機械製造メーカー",
                "航空機label":"機械製造メーカー",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般counter":20,
                "航空機counter":20
            }},
            {key:"製造メーカー名_機体", 
             value:{
                "一般label":"機体製造メーカー",
                "航空機label":"AIRCRAFT MAKER",
                "一般message":"-",
                "航空機message":"機体製造メーカー",
                "一般証明書":false,
                "航空機証明書": false,
                "一般counter":20,
                "航空機counter":15
            }},
            {key:"機械の種類", 
             value:{
                "一般label":"機械の種類",
                "航空機label":"機械の種類",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"機械の詳細", 
             value:{
                "一般label":"機械の詳細",
                "航空機label":"機械の詳細",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"機械の詳細（その他）", 
             value:{
                "一般label":"機械の詳細（その他）",
                "航空機label":"機械の詳細（その他）",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},

            {key:"型式", 
             value:{
                "一般label":"機械型式",
                "航空機label":"SAMPLE COMPONENT MODEL",
                "一般message":"-",
                "航空機message":"機械型式",
                "一般証明書":true,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"機械の型式を入力してください。",
                "航空機description":"装備品の部品番号（P/N）を入力してください。",
            }},
            {key:"型式_機体", 
             value:{
                "一般label":"機体型式",
                "航空機label":"AIRCRAFT MODEL",
                "一般message":"-",
                "航空機message":"機体型式",
                "一般証明書":false,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"機体の製品番号（P/N）を入力してください。",
                "航空機description":"機体の型式（P/N）を入力してください。",
            }},
            {key:"搭載位置", 
             value:{
                "一般label":"搭載位置",
                "航空機label":"POSITION",
                "一般message":"-",
                "航空機message":"搭載位置",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"エンジンなどのPOSITIONを入力ください。 (例)1,2",
                "航空機description":"エンジンなどのPOSITIONを入力ください。 (例)1,2",
            }},

            {key:"機器導入日", 
             value:{
                "一般label":"機械導入日",
                "航空機label":"機械導入日",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"機器導入日_機体", 
             value:{
                "一般label":"機体導入日",
                "航空機label":"機体導入日",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},

            {key:"累計使用時間／距離", 
             value:{
                "一般label":"機械使用時間／距離",
                "航空機label":"SAMPLE T.T",
                "一般message":"-",
                "航空機message":"機械使用時間",
                "一般証明書":true,
                "航空機証明書": true,
                "一般description":"機器の総使用時間を入力してください",
                "航空機description":"Sample Component Total Time（装備品の総使用時間）を入力してください。",
            }},
            {key:"累計使用時間／距離_機体", 
             value:{
                "一般label":"機体使用時間／距離",
                "航空機label":"AIRCRAFT T.T",
                "一般message":"-",
                "航空機message":"機体使用時間",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"機体の総使用時間を入力してください。",
                "航空機description":"Aircraft Total Time（機体の総使用時間）を入力してください。",
            }},
            {key:"修理日", 
             value:{
                "一般label":"ｵｰﾊﾞｰﾎｰﾙ日",
                "航空機label":"ｵｰﾊﾞｰﾎｰﾙ日",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"修理後使用時間／距離", 
             value:{
                "一般label":"ｵｰﾊﾞｰﾎｰﾙ後使用時間／距離",
                "航空機label":"SAMPLE TSO",
                "一般message":"-",
                "航空機message":"ｵｰﾊﾞｰﾎｰﾙ後使用時間",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"前回オーバーホール後の使用時間を入力してください。",
                "航空機description":"Sample Component Time Since Overhaul（装備品の前回オーバーホール後の使用時間）を入力してください。",
            }},
            {key:"修理後使用時間／距離_機体", 
             value:{
                "一般label":"ｵｰﾊﾞｰﾎｰﾙ後使用時間／距離",
                "航空機label":"AIRCRAFT TSO",
                "一般message":"-",
                "航空機message":"ｵｰﾊﾞｰﾎｰﾙ後使用時間",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"前回オーバーホール後の使用時間を入力してください。",
                "航空機description":"Aircraft Time Since Overhaul（機体の前回オーバーホール後の使用時間）を入力してください。",
            }},
            {key:"修理メモ", 
             value:{
                "一般label":"ｵｰﾊﾞｰﾎｰﾙﾒﾓ（自由入力）",
                "航空機label":"ｵｰﾊﾞｰﾎｰﾙﾒﾓ（自由入力）",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"オーバーホールに関するメモを自由に入力してください。",
                "航空機description":"オーバーホールに関するメモを自由に入力してください。",
            }},
            {key:"オイル交換メモ", 
             value:{
                "一般label":"オイル交換メモ（自由入力）",
                "航空機label":"オイル交換メモ（自由入力）",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"オイル交換メモに関するメモを自由に入力してください。",
                "航空機description":"オイル交換メモに関するメモを自由に入力してください。",
            }},
            {key:"マイ機器メモ", 
             value:{
                "一般label":"メモ（自由入力）",
                "航空機label":"メモ（自由入力）",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"機器に関するメモとしてご活用ください。（修理、部品交換歴や、機器に関する備忘）\n ※報告書には反映されません。",
                "航空機description":"装備品に関するメモとしてご活用ください。（修理、部品交換歴や、機器に関する備忘）\n ※報告書には反映されません。",
            }},

            {key:"システム油量", 
             value:{
                "一般label":"システム油量",
                "航空機label":"OIL QUANTITY",
                "一般message":"-",
                "航空機message":"システム油量",
                "一般証明書":true,
                "航空機証明書": true,
                "一般description":"機器に注油するオイル量（システム油量）を入力してください。",
                "航空機description":"装備品に注油するオイル量（システム油量）を入力してください。",
            }},
            {key:"オイルの種類", 
             value:{
                "一般label":"オイルの種類",
                "航空機label":"オイルの種類",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"オイルの詳細", 
             value:{
                "一般label":"オイルの詳細",
                "航空機label":"オイルの詳細",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般counter":20,
                "航空機counter":20,
                "一般description":"オイルの詳細を選択してください。",
                "航空機description":"オイルの詳細を選択してください。",
            }},
            {key:"オイルの詳細（その他）", 
             value:{
                "一般label":"オイルの詳細（その他）",
                "航空機label":"オイルの詳細（その他）",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般counter":20,
                "航空機counter":20,
                "一般description":"その他の場合はオイルの詳細を入力してください。（熱処理油、熱媒体油など）",
                "航空機description":"その他の場合はオイルの詳細を入力してください。（熱処理油、熱媒体油など）",
            }},

            {key:"オイルの性質", 
             value:{
                "一般label":"オイルの性質",
                "航空機label":"オイルの性質",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"この機器で使用しているオイルが油性、水溶性かを選択してください。",
                "航空機description":"この機器で使用しているオイルが油性、水溶性かを選択してください。",
            }},
            {key:"オイルの状態", 
             value:{
                "一般label":"オイルの状態",
                "航空機label":"オイルの状態",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"この機器で使用しているオイルが新油、使用油かを選択してください。",
                "航空機description":"この機器で使用しているオイルが新油、使用油かを選択してください。",
            }},
            {key:"使用オイル", 
             value:{
                "一般label":"オイル名",
                "航空機label":"OIL TYPE",
                "一般message":"使用オイル",
                "航空機message":"使用オイル",
                "一般証明書":true,
                "航空機証明書": true
            }},
            {key:"使用オイルメーカー", 
             value:{
                "一般label":"使用オイルメーカー",
                "航空機label":"使用オイルメーカー",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"使用オイル銘柄", 
             value:{
                "一般label":"オイル名",
                "航空機label":"OIL TYPE",
                "一般message":"使用オイル銘柄",
                "航空機message":"使用オイル銘柄",
                "一般証明書":true,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"報告書に記載されるオイル名です。\nわからない場合は「不明」と入力してください。",
                "航空機description":"報告書に記載されるオイル名です。\nわからない場合は「Unknown」と入力してください。",
            }},
            {key:"使用オイルグレード", 
             value:{
                "一般label":"使用オイルグレード",
                "航空機label":"使用オイルグレード",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"オイル交換日", 
             value:{
                "一般label":"オイル交換日",
                "航空機label":"オイル交換日",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"オイル交換、補充した日付を選択してください。",
                "航空機description":"オイル交換、補充した日付を選択してください。",
            }},
            {key:"オイル交換有無", 
             value:{
                "一般label":"オイル交換有無",
                "航空機label":"OIL CHANGE",
                "一般message":"-",
                "航空機message":"オイル交換有無",
                "一般証明書":false,
                "航空機証明書": true
            }},
            {key:"オイル交換量", 
             value:{
                "一般label":"オイル交換量",
                "航空機label":"OIL ADDED",
                "一般message":"-",
                "航空機message":"オイル交換量",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"オイル交換、補充したオイル量を入力してください。",
                "航空機description":"オイル交換、補充したオイル量を入力してください。",
            }},
            {key:"オイル使用時間", 
             value:{
                "一般label":"オイル使用時間／距離",
                "航空機label":"SAMPLE TSOD",
                "一般message":"-",
                "航空機message":"オイル使用時間",
                "一般証明書":true,
                "航空機証明書": true,
                "一般description":"前回オイル交換後の使用時間を入力してください。",
                "航空機description":"Sample Component Time Since Oil Drain（前回オイル交換後の使用時間）を入力してください。",
            }},
            {key:"フィルター使用", 
             value:{
                "一般label":"オイルフィルター",
                "航空機label":"オイルフィルター",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"フィルター使用時間", 
             value:{
                "一般label":"フィルター使用時間／距離",
                "航空機label":"FIRTER T.T",
                "一般message":"-",
                "航空機message":"フィルター使用時間",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"フィルターの総使用時間を入力してください。",
                "航空機description":"Firter Total Time（フィルターの総使用時間）を入力してください。",
            }},
            {key:"サンプル採取場所", 
             value:{
                "一般label":"サンプル採取場所",
                "航空機label":"SAMPLE PLACE",
                "一般message":"-",
                "航空機message":"サンプル採取場所",
                "一般証明書":false,
                "航空機証明書": true,
                "一般counter":12,
                "航空機counter":12,
                "一般description":"オイルを採取した場所を入力してください。（東京、神奈川など）",
                "航空機description":"オイルを採取した場所を入力してください。（TOKYO、KANAGAWAなど）",
            }},
            {key:"前回分析依頼日", 
             value:{
                "一般label":"前回分析依頼日",
                "航空機label":"前回分析依頼日",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"前回分析依頼番号", 
             value:{
                "一般label":"前回分析依頼番号",
                "航空機label":"前回分析依頼番号",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般counter":10,
                "航空機counter":10,
                "一般description":"報告書に記載されている依頼番号を入力してください\n（例：59999999）",
                "航空機description":"報告書に記載されている依頼番号を入力してください\n（例：59999999）",
            }},
            {key:"危険物の内容", 
             value:{
                "一般label":"使用オイルの危険物の内容",
                "航空機label":"使用オイルの危険物の内容",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"オイルに含まれる危険物情報をできるだけ詳細に入力してください。",
                "航空機description":"オイルに含まれる危険物情報をできるだけ詳細に入力してください。",
            }},
            
            {key:"分析方法", 
             value:{
                "一般label":"分析方法",
                "航空機label":"分析方法",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"分析区分", 
             value:{
                "一般label":"分析区分",
                "航空機label":"分析区分",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"オイルの種類に応じて分析区分が決定します。\n変更したい場合はオイルの種類を選択し直してください。",
                "航空機description":"オイルの種類に応じて分析区分が決定します。\n変更したい場合はオイルの種類を選択し直してください。",
            }},
            {key:"セット分析", 
             value:{
                "一般label":"セット分析",
                "航空機label":"セット分析",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"主要な分析項目のセットです。\n個別にご依頼いただくよりお得です。",
                "航空機description":"主要な分析項目のセットです。\n個別にご依頼いただくよりお得です。",
            }},
            {key:"セット分析項目", 
             value:{
                "一般label":"セット分析に含まれる分析項目",
                "航空機label":"セット分析に含まれる分析項目",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false
            }},
            {key:"個別分析項目", 
             value:{
                "一般label":"個別分析項目",
                "航空機label":"個別分析項目",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"ご希望の分析項目を選択してください。\n分析セットに追加することも可能です。",
                "航空機description":"ご希望の分析項目を選択してください。\n分析セットに追加することも可能です。",
            }},
            {key:"フィルター返却", 
             value:{
                "一般label":"フィルター返却",
                "航空機label":"フィルター返却",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"分析に使用したフィルターの返却をご希望の方は選択します。\nラミネート加工で有無で費用が異なります。",
                "航空機description":"分析に使用したフィルターの返却をご希望の方は選択します。\nラミネート加工で有無で費用が異なります。",
            }},
            {key:"サンプル返却", 
             value:{
                "一般label":"サンプル返却",
                "航空機label":"サンプル返却",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"サンプルの残油の返却をご希望の方は選択します。\n希望されない場合、残油はジャパン・アナリストにて廃棄いたします。",
                "航空機description":"サンプルの残油の返却をご希望の方は選択します。\n希望されない場合、残油はジャパン・アナリストにて廃棄いたします。",
            }},
            {key:"分析目的", 
             value:{
                "一般label":"分析目的",
                "航空機label":"分析目的",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"分析目的がございましたら入力してください。（定期分析、スポット分析など）",
                "航空機description":"分析目的がございましたら入力してください。（定期分析、スポット分析など）",
            }},
            {key:"サンプル名", 
             value:{
                "一般label":"サンプル名",
                "航空機label":"REGISTRATION NUMBER（S/N）",
                "一般message":"-",
                "航空機message":"サンプル名",
                "一般証明書":true,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":15,
                "一般description":"サンプルを識別する名称を入力してください。",
                "航空機description":"サンプルを識別する名称を入力してください。",
           }},
            {key:"採取日", 
             value:{
                "一般label":"採取日",
                "航空機label":"DATE TAKEN",
                "一般message":"-",
                "航空機message":"採取日",
                "一般証明書":false,
                "航空機証明書": true
            }},
            {key:"採取者", 
             value:{
                "一般label":"採取者",
                "航空機label":"SAMPLER",
                "一般message":"-",
                "航空機message":"採取者",
                "一般証明書":false,
                "航空機証明書": true,
                "一般counter":20,
                "航空機counter":12,
                "一般description":"オイルの採取者を入力してください。",
                "航空機description":"オイルの採取者を入力してください。",
            }},
            {key:"サンプルメモ", 
             value:{
                "一般label":"サンプルメモ",
                "航空機label":"サンプルメモ",
                "一般message":"ジャパン・アナリストへの伝達事項",
                "航空機message":"ジャパン・アナリストへの伝達事項",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"サンプルや分析内容について、ジャパン・アナリストへの伝達事項があれば入力してください。",
                "航空機description":"サンプルや分析内容について、ジャパン・アナリストへの伝達事項があれば入力してください。",
            }},
            {key:"ボトル数", 
             value:{
                "一般label":"ボトル数",
                "航空機label":"ボトル数",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"サンプルが2本以上に分かれる場合はサンプルの本数を入力します。",
                "航空機description":"サンプルが2本以上に分かれる場合はサンプルの本数を入力します。",
            }},
            {key:"サンプル数", 
             value:{
                "一般label":"サンプル数",
                "航空機label":"サンプル数",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"同じ分析内容のサンプルが複数ある場合、サンプル数を入力して下さい。",
                "航空機description":"同じ分析内容のサンプルが複数ある場合、サンプル数を入力して下さい。",
            }},
            {key:"送付予定日", 
             value:{
                "一般label":"送付予定日",
                "航空機label":"DATE POSTED",
                "一般message":"-",
                "航空機message":"送付予定日",
                "一般証明書":false,
                "航空機証明書": true,
                "一般description":"オイル送付予定日を入力してください。",
                "航空機description":"オイル送付予定日を入力してください。",
            }},

            {key:"必要オイル量", 
             value:{
                "一般label":"必要オイル量",
                "航空機label":"必要オイル量",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"分析に必要なサンプル量です。\nこの量より多くサンプル採取してください。",
                "航空機description":"分析に必要なサンプル量です。\nこの量より多くサンプル採取してください。",
            }},
            {key:"分析料金", 
             value:{
                "一般label":"分析料金（税抜き）",
                "航空機label":"分析料金（税抜き）",
                "一般message":"-",
                "航空機message":"-",
                "一般証明書":false,
                "航空機証明書": false,
                "一般description":"標準の分析費用です。\nご依頼の内容によって実際の請求額と異なる場合がございます。",
                "航空機description":"標準の分析費用です。\nご依頼の内容によって実際の請求額と異なる場合がございます。",
            }},

            {key:"お問い合わせ番号", 
            value:{
               "一般label":"お問い合わせ番号",
               "航空機label":"お問い合わせ番号",
               "一般message":"危険物等に関するお問合せ番号",
               "航空機message":"危険物等に関するお問合せ番号",
               "一般証明書":false,
               "航空機証明書": false
           }},

           {key:"注文番号", 
           value:{
              "一般label":"お客様内注文番号",
              "航空機label":"お客様内注文番号",
              "一般message":"-",
              "航空機message":"-",
              "一般証明書":false,
              "航空機証明書": false,
              "一般description":"お客様内で管理する注文番号を入力して下さい。\n入力は任意です。",
              "航空機description":"お客様内で管理する注文番号を入力して下さい。\n入力は任意です。",
          }},
          {key:"見積り案件名", 
          value:{
             "一般label":"お見積もり案件名",
             "航空機label":"お見積もり案件名",
             "一般message":"-",
             "航空機message":"-",
             "一般証明書":false,
             "航空機証明書": false,
             "一般description":"お見積り依頼を識別する名称を入力できます。\nご自由に入力して下さい。",
             "航空機description":"お見積り依頼を識別する名称を入力できます。\nご自由に入力して下さい。",
         }},

        ]
    }),
    methods: {
/*
        includeItem: async function () {
           const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
            if(AnalizeSetName[0]) {
                this.AnalizeSetName = AnalizeSetName[0].Text
                this.AnalizeSetItems = AnalizeSetName[0].AnalizeItems
                let AnalizeSetItemNames = JSON.parse(AnalizeSetName[0].AnalizeItemNames)
//                console.log('■■this.AnalizeItems ',this.AnalizeItems)
//                console.log('■■this.AnalizeSetItemNames ',AnalizeSetItemNames)
                try {
                    this.AnalizeItems = JSON.parse(this.AnalizeSetItems)
                } catch (e) {
                    const replaced = this.AnalizeSetItems.replace(/'/g,"\"")
                    console.log('replaced AnalizeSetItems', replaced)
                    this.AnalizeItems = JSON.parse(replaced)
                }
                if (this.analizeItemList) {
                // セットに含まれる分析項目を、個別分析項目の選択肢からはずす
                for (var items in this.AnalizeItems) {
                    var addData = this.analizeItemList.filter(item => item.Value  == this.AnalizeItems[items])
                    if(addData[0]) {
                        // 該当する分析区分で選択できる分析項目のリストから、
                        // セットに含まれる分析項目「以外」を抽出しながら（絞込みながら）回る
                        this.analizeItemList = this.analizeItemList.filter(item => item.Value  != this.AnalizeItems[items])
                    }
                }
                // セットに含まれる分析項目表示するための配列を作る
                this.analizeItemListInclude = []
                this.AnalizeItemsInclude = []
                for (var index in AnalizeSetItemNames) {
//                    console.log('■■name ',AnalizeSetItemNames[index])
                    let _item = {
                        Text: AnalizeSetItemNames[index],
                        Value: index
                    }
                    // Valueの配列
                    this.AnalizeItemsInclude.push(index)
                    // TextとValueを持ったjsonの配列
                    this.analizeItemListInclude.push(_item)
                }
                }
//                console.log('analizeItemList', this.analizeItemList)
                this.AnalizeItems = []
            }else {
                console.log('not found analizeset ',this.AnalizeSet)
                this.AnalizeItems = []
            }
            this.isItemsInclude = true
        },
        clearAnalizeSet: async function () {
            // console.log('クリアがクリック', this.AnalizeTypeName, this.AnalizeType)
            const itemlist = this.$store.state.analizeItemList.filter(item => item.AnalizeType  == this.AnalizeType)
            this.AnalizeItems = ""
            this.analizeItemList = itemlist[0].AnalizeItems
          },
*/
        isDiscountCompany: function () {
            console.log('isDiscountCompany Ratio', this.$store.state.operatingCompany.Ratio)
            console.log('isDiscountCompany contractCompany', this.$store.state.isContractCompany)
//            if((this.$store.state.operatingCompany.Ratio == "100") && (this.$store.state.isContractCompany == false)){
            if(this.$store.state.operatingCompany.Ratio == "100") {
                console.log('WEB割引対象です')
                return true
            }
            console.log('WEB割引対象ではないです')
            return false
        },
        moveToTop() {
            const duration = 50; // 移動速度（50msで終了）
            const interval = 50; // 50msごとに移動
            const step = -window.scrollY / Math.ceil(duration / interval); // 1回に移動する距離
            const timer = setInterval(() => {
                window.scrollBy(0, step);   // スクロール位置を移動
                if(window.scrollY <= 0) {
                  clearInterval(timer);
                }
            }, interval);
        },
        getItemName: function(key) {
            let value = this.itemNames.filter(item => item.key == key)
            if(value[0])
                return value[0].value
            else
                return {"一般label":"not found" + key, "一般message":"", "航空機message":""}
        },
        getMachineAnalizeTypeCategory: function(machine) {
            let analizeTypeCategory = ""
            let category = machine.AnalizeType.substring(0, 1)
            switch(category) {
                case "1":
                analizeTypeCategory = "一般"
                break
                case "2":
                analizeTypeCategory = "航空機"
                break
                default:
                analizeTypeCategory = "JXTG"
                break
            }
            return analizeTypeCategory
        },

        getApplicationAnalizeTypeCategory: function(application) {
            let analizeTypeCategory = application.AnalizeTypeCategory
            if(analizeTypeCategory == undefined) {
                analizeTypeCategory = "一般"
            }
            return analizeTypeCategory
        },
        getSampleAnalizeTypeCategory: function(sample) {
            let analizeTypeCategory = ""
            let category = sample.AnalizeType.substring(0, 1)
            switch(category) {
                case "1":
                analizeTypeCategory = "一般"
                break
                case "2":
                analizeTypeCategory = "航空機"
                break
                default:
                analizeTypeCategory = "JXTG"
                break
            }
            return analizeTypeCategory

        },
/*
        getApplicationAnalizeTypeCategory: function(application) {
            let analizeTypeCategory = ""
            let category = "1"
            let _category = application.AnalizeType
            if(_category != undefined) {
                category = application.AnalizeType.substring(0, 1)
            }
            console.log("getApplicationAnalizeTypeCategory", category)
            switch(category) {
              case "1":
                analizeTypeCategory = "一般"
                break
              case "2":
                analizeTypeCategory = "航空機"
                break
              default:
                analizeTypeCategory = "JXTG"
                break
            }
            return analizeTypeCategory
        },
*/
        getMachineType: function(machine) {
            // フェーズ2.4以前のデータはTypeがないので補完する
            let type = machine.Type
            console.log("machine type:", type)
            if(type == undefined) {
              type = "装備装置"
            }
            return type
        },
        getMachineCategoryList: async function(analizeTypeCategory, machineType) {
            let _machineCategory = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "machineCategory" + analizeTypeCategory + machineType}))
            return _machineCategory.data.sortedCodesByType.items
        },
        getMachineTypeList: async function(machineCategory) {
            let _machineCategory = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "machineType" + machineCategory}))
            return _machineCategory.data.sortedCodesByType.items
        },
        getAnalizeTypeList: async function(analizeTypeGroup) {
            let _analizeTypelist = await API.graphql(graphqlOperation(analizeTypeByGroup, {AnalizeTypeGroup: analizeTypeGroup}))
            return _analizeTypelist.data.analizeTypeByGroup.items
        },
        getAnalizeSetList: async function(analizeType) {
            //----------------------------------------
            // 分析セット
            //  共通 Company=0000000000 
            //  企業別特別セット Company=企業コード
            let setFilter = {
                or: [
                { Company: {eq: "0000000000"} },
                { Company: {eq: this.$store.state.operatingOffice.CompanyID} },
                ]
            }
            let _analizeSetList = await API.graphql(graphqlOperation(sortedAnalizeSetByType, {AnalizeType: analizeType, filter:setFilter, limit:300}))
            let analizeSetList = _analizeSetList.data.sortedAnalizeSetByType.items
            
            // isActiveが"0"のレコードを除外
            analizeSetList = analizeSetList.filter(item => item.isActive !== "0")
            
            console.log("★★getAnalizeSetList:", analizeSetList)
            return analizeSetList
          },
        getAnalizeItemList: async function(analizeType) {
            //----------------------------------------
            // 分析項目
            let _analizeItemList = await API.graphql(graphqlOperation(sortedAnalizeItemByType, {AnalizeType: analizeType, limit:300} ))
            let analizeItemList = _analizeItemList.data.sortedAnalizeItemByType.items

            // isActiveが"0"のレコードを除外
            analizeItemList = analizeItemList.filter(item => item.isActive !== "0")

            let _analizeItem4ComList = await API.graphql(graphqlOperation(analizeItemByCompany, {CompanyID: this.$store.state.operatingOffice.CompanyID} ))
            let analizeItem4ComList = _analizeItem4ComList.data.analizeItemByCompany.items

            for (var analizeItem4com of analizeItem4ComList) {
                // 得意先（企業）別分析項目で上書き
                var replaceAnalizeItem = analizeItemList.filter(item => item.Value  == analizeItem4com.Value)
                if(replaceAnalizeItem[0]) {
                    replaceAnalizeItem[0].RegularPrice = replaceAnalizeItem[0].Price
                    replaceAnalizeItem[0].Price = analizeItem4com.Price
                    if(analizeItem4com.CustomText) {
                        replaceAnalizeItem[0].Text = analizeItem4com.CustomText
                    }
                }
            }
            console.log("★★getAnalizeItemList:", analizeItemList)
            return analizeItemList
        }, 
/*
        getAnalizeItemNames: async function(analizeItems, analizeItemList) {
*/
        getAnalizeItemNames: async function(analizeItems, analizeItemSub, analizeItemList, analizeItemSubList) {
            let analizeItemNames = []
            
            for (var parentItem of Object.keys(analizeItemSub)) {
                if(!analizeItems.includes(parentItem)) {
                    let _analizeItemSub = analizeItemSub[parentItem]
                    let _analizeItemSubList = analizeItemSubList[parentItem]
                    for (const _analizeItem of _analizeItemSub) {
                        console.log("_analizeItemSubList:" + _analizeItem)
                        let item = _analizeItemSubList.filter(item => item.Value  == _analizeItem)
                        analizeItemNames.push(item[0].Text)
                    }
                }
            }
             
            for (var analizeItem of analizeItems) {
                let _analizeItem = analizeItemList.filter(item => item.Value  == analizeItem)
                if(_analizeItem[0]) {
                    analizeItemNames.push(_analizeItem[0].Text)
                }else {
                    analizeItemNames.push(analizeItem)
                }

                // 追加項目（子の分析項目）がある場合、挟みこみ
                if(analizeItemSub) {
                    let _analizeItemSub = analizeItemSub[analizeItem]
                    if(_analizeItemSub) {
                        let _analizeItemSubList = analizeItemSubList[analizeItem]
                        if(_analizeItemSubList) {
                            for (const _analizeItem of _analizeItemSub) {
                                let item = _analizeItemSubList.filter(item => item.Value  == _analizeItem)
                                analizeItemNames.push(item[0].Text)
                            }
                        }
                    }
                }
            }
            return analizeItemNames
        },
/*
        getAnalizeItemSubList: async function(analizeType) {
            let _analizeItemSubList = await API.graphql(graphqlOperation(analizeItemSubByType, {AnalizeType: analizeType, limit:300} ))
            let analizeItemSubList = _analizeItemSubList.data.analizeItemSubByType.items

            let aa = {}
            for (var analizeItemSub of analizeItemSubList) {
                let parent = aa[analizeItemSub.Parent]
                if(parent == undefined) {
                    let bb = []
                    bb.push(analizeItemSub)
                    aa[analizeItemSub.Parent] = bb
                }else {
                    parent.push(analizeItemSub)
                }
            }
            return aa
        },
*/
        getAnalizeItemSubList: async function(analizeType) {
            let _analizeItemSubList = await API.graphql(graphqlOperation(analizeItemSubByType, {AnalizeType: analizeType, limit:300} ))
            let analizeItemSubList = _analizeItemSubList.data.analizeItemSubByType.items

            let parentList = {}
            for (var analizeItemSub of analizeItemSubList) {
                let parent = parentList[analizeItemSub.Parent]
                if(parent == undefined) {
                    let itemList = []
                    itemList.push(analizeItemSub)
                    parentList[analizeItemSub.Parent] = itemList
                }else {
                    parent.push(analizeItemSub)
                }
            }
            return parentList
        },

        excludeAnalizeItems: async function (excludeItems, analizeItems) {
            let excludedItems = analizeItems

            let _excludeItems = JSON.parse(excludeItems)
            
            // セットに含まれる分析項目を、個別分析項目の選択肢からはずす
            for (var analizeItem of _excludeItems) {
                try {
                    excludedItems = excludedItems.filter(item => item.Value  != analizeItem)
                }catch(Error) {
                    console.log("excludeAnalizeItems", Error)
                }
            }
            return excludedItems
        },
        getAnalizeSetItems: async function(analizeSet) {
            // セットに含まれる分析項目表示するための配列を作る
            let analizeSetItems = []
//            this.analizeItemListInclude = []
//            this.AnalizeItemsInclude = []

            let _analizeSetItems = JSON.parse(analizeSet.AnalizeItems)
            let _analizeSetItemsNames = JSON.parse(analizeSet.AnalizeItemNames)

            for (var index in _analizeSetItems) {
                let _item = {
                    Text: _analizeSetItemsNames[index],
                    Value: _analizeSetItems[index]
                }
                analizeSetItems.push(_item)
            }
            return analizeSetItems
        },
        getAnalizeTypeGroupList: async function(analizeTypeCategory) {
            let _analizeTypeGroupList = await API.graphql(graphqlOperation(analizeTypeGroupByCategory, {AnalizeTypeCategory: analizeTypeCategory}))
            return _analizeTypeGroupList.data.analizeTypeGroupByCategory.items
        },
        getOilTypeCategoryList: async function(analizeTypeCategory) {
            let _oilCategory = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "oilCategory" + analizeTypeCategory}))
            return _oilCategory.data.sortedCodesByType.items
        },
        getOilTypeList: async function(oilCategory) {
            let _oilTypeList = await API.graphql(graphqlOperation(oilTypeByCategory, {OilCategory: oilCategory}))
            let oilTypeList = _oilTypeList.data.oilTypeByCategory.items
            return oilTypeList
        },
        getFilterText(Filter) {
            let FilterText = ""
            switch(Filter) {
                case "001":
                    FilterText = "不要"
                    break
                case "002":
                    FilterText = "必要（ラミネート加工あり）"
                    break
                default:
                    FilterText = "必要（ラミネート加工なし）"
                    break
            }
            return FilterText
        },
        getSurplusText(Surplus) {
            let SurplusText = ""
            switch(Surplus) {
                case "0":
                    SurplusText = "不要"
                    break
                default:
                    SurplusText = "必要"
                    break
            }
            return SurplusText

        },
        isOtherOilType(oilType) {
            let isOther = false
            switch(oilType) {
                case "01001001":
                case "02001101":
                case "03001101":
                case "04001101":
                case "05001101":
                    isOther = true
                    break
                default:
                    isOther = false
                    break
            }
            return isOther
        },
        getAnalizeSetCompanyList: async function(analizeType, analizeSetValue) {
            // sortedAnalizeSetByTypeを使用して分析区分と分析セットを指定してレコードを取得
            let _analizeSetList = await API.graphql(graphqlOperation(sortedAnalizeSetByType, {
                AnalizeType: analizeType, 
                Value: {eq: analizeSetValue},
                limit: 300
            }))
            let analizeSetList = _analizeSetList.data.sortedAnalizeSetByType.items
            
            // Companyの一覧を取得（重複を除去）
            let companyList = [...new Set(analizeSetList.map(item => item.Company))]
            
            return companyList
        }
    }
};